import { Component, inject, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { PrimeNGConfig } from 'primeng/api';
import { Subject } from 'rxjs';
import { DateUtil } from '../../ui/DateUtil';

@Component({
  selector: 'app-datetime-field',
  templateUrl: './datetime-picker.component.html',
  styleUrls: ['./datetime-picker.component.css'],
})
export class DatetimePickerComponent extends FieldType implements OnInit {

  primengConfig = inject(PrimeNGConfig);
  observer = new Subject();

  date: any = null;
  dateFormat = 'dd/mm/yy';
  dateFormatCode = 102;

  dateFormatFieldName = '';
  dateFieldName = '';

  isReadOnlyInput = true;
  showFormat = false;
  calendarView = 'date';
  placeholder: string | undefined = undefined;


ngOnInit() {
  this.props['clearDate'] = () => this.clearDate();
  this.initializeFieldNames();

  const raw = this.formControl.parent?.get(this.dateFieldName)?.value;
  if (raw) {
    this.dateFormatCode =
      this.formControl.parent?.get(this.dateFormatFieldName)?.value ??
      DateUtil.detectDateFormat(raw);

    const parsed = DateUtil.importDate(raw, this.dateFormatCode);
    this.formControl.setValue(parsed); 
    this.date = parsed; 
    this.setCalendarView();
  }
}

onSelect() {
  const current = this.formControl.value;
  if (!current) {
    this.clearDate();
    return;
  }

  this.formControl.parent?.get(this.dateFormatFieldName)
    ?.setValue(this.dateFormatCode);

  this.formControl.parent?.get(this.dateFieldName)
    ?.setValue(DateUtil.exportDate(current, this.dateFormatCode));

  this.updateDateFormatLocale();
}

  initializeFieldNames() {
    const keys = this.field.props?.['keys'] ?? [];
    this.dateFormatFieldName = keys[0];
    this.dateFieldName = keys[1];
    this.showFormat = this.props['showFormat'] || false;
    this.placeholder = this.props.placeholder || undefined;
  }

  initializeDateFromModel() {
    const dateValue = this.formControl.parent?.get(this.dateFieldName)?.value;

    if (dateValue) {
      this.dateFormatCode =
        this.formControl.parent?.get(this.dateFormatFieldName)?.value
        ?? DateUtil.detectDateFormat(dateValue);

      this.date = DateUtil.importDate(dateValue, this.dateFormatCode);
      this.setCalendarView();
    }
  }

  registerValueChanges() {
    this.formControl.valueChanges.subscribe(value => {
      if (!value) return;
      this.date = value;
    });
  }

  setCalendarView() {
    switch (Number(this.dateFormatCode).valueOf()) {
      case 610:
        this.calendarView = 'month';
        this.dateFormat = 'mm/yy';
        break;
      default:
        this.calendarView = 'date';
        this.dateFormat = 'dd/mm/yy';
        break;
    }
  }

setDateFormat(format: string) {
  this.dateFormat = format;
  this.dateFormatCode = format === 'mm/yy' ? 610 : 102;

  this.clearDate();

  this.setCalendarView();
}

clearDate() {
  const parent = this.formControl.parent;

  this.date = null;

  this.formControl.reset();

  setTimeout(() => {
    this.formControl.setValue(null, { emitEvent: false });
  });

  parent?.get(this.dateFieldName)?.setValue(null);
  parent?.get(this.dateFormatFieldName)?.setValue(null);
}

  updateDateFormatLocale() {
    this.primengConfig.translationObserver = this.observer;
    this.primengConfig.setTranslation({ dateFormat: this.dateFormat });
    this.observer.next('setTranslation');
  }


  saveModelValue() {
    if (!this.date) {
      this.clearDate();
      return;
    }
    this.formControl.parent?.get(this.dateFormatFieldName)
      ?.setValue(this.dateFormatCode);

    this.formControl.parent?.get(this.dateFieldName)
      ?.setValue(DateUtil.exportDate(this.date, this.dateFormatCode));
  }

  onFocus() { this.isReadOnlyInput = false; }
  onBlur() { this.isReadOnlyInput = true; }
}
